import * as T from 'src/store/types'
import Vue from 'vue'
import {
  SET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS,
  SET_ESAC_POINTS_REDEMPTION_DATA,
  SET_ESAC_POINTS_REDEMPTION_LIST,
  UNSET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS,
} from 'src/store/types'

export default {
  [T.SET_ESAC_POINTS_VOUCHER_DATA](state, payload = {}) {
    Vue.set(state.voucherData, 'data', payload)
  },
  [T.SET_ESAC_POINTS_VOUCHER_LIST](state, payload = false) {
    Vue.set(
      state.voucherList,
      'list',
      payload
        ? payload.list
        : {
            data: [],
            total: 0,
          }
    )
  },
  [T.SET_ESAC_POINTS_REDEMPTION_LIST](state, payload) {
    Vue.set(state.redemptionList, 'list', payload.list)
  },
  [T.SET_ESAC_POINTS_REDEMPTION_DATA](state, payload) {
    Vue.set(state.redemption, 'data', payload.data)
  },
  [T.SET_ITOKEN_ACCUMULATE_CALCULATION_LIST](state, payload) {
    Vue.set(state.accumulateCalculationList, 'list', payload.list)
  },
  [T.SET_ESAC_POINTS_BALANCE](state, data) {
    state.balance = data
  },
  [T.SET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS](state, payload) {
    let availableIndex = state.cartAdditionalAttributesInCompleteIds[payload.key].findIndex(x => x === payload.id)
    if (availableIndex === -1) {
      state.cartAdditionalAttributesInCompleteIds[payload.key].push(payload.id)
    }
  },
  [T.UNSET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS](state, payload) {
    if (payload !== undefined && payload.key !== undefined && payload.id !== undefined) {
      let removeIndex = state.cartAdditionalAttributesInCompleteIds[payload.key].findIndex(x => x === payload.id)
      if (removeIndex !== -1) {
        state.cartAdditionalAttributesInCompleteIds[payload.key].splice(removeIndex, 1)
      }
    } else {
      state.cartAdditionalAttributesInCompleteIds['product_ids'].splice(
        0,
        state.cartAdditionalAttributesInCompleteIds['product_ids'].length
      )
      state.cartAdditionalAttributesInCompleteIds['kitting_ids'].splice(
        0,
        state.cartAdditionalAttributesInCompleteIds['kitting_ids'].length
      )
    }
  },
}
